import React, { useState } from "react";
import { footerData } from "./FooterData";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/home/home.png";
import { ChevronDown, ChevronUp } from "lucide-react";
import {
  FaFacebook,
  FaLinkedin,
  FaPinterest,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import FooterTabbing from "../home/FooterTabbing";
import FooterTabbingBuys from "../home/FooterTabbingBuys";

const flattenFooterData = (section) => {
  if (!section) return [];
  return [].concat(
    section.data1 || [],
    section.data2 || [],
    section.data3 || [],
  );
};

const Footer = () => {
  const pathName = useLocation().pathname;
  const [openAccordions, setOpenAccordions] = useState({
    "Real estate": true,
    Company: true,
  });

  const realEstateLinks = flattenFooterData(footerData["Real estate"]);
  const accordionSections = [
    {
      id: "Real estate",
      title: "Real estate",
      links: realEstateLinks.length
        ? realEstateLinks
        : [
          { propertyName: "Real estate in Nigeria", propertyLink: "/buy" },
          { propertyName: "Real estate in Lagos", propertyLink: "/buy" },
          { propertyName: "Real estate in Abuja", propertyLink: "/buy" },
          { propertyName: "Real estate in Harcourt", propertyLink: "/buy" },
          { propertyName: "Real estate in Enugu", propertyLink: "/buy" },
          { propertyName: "Real estate in Ibadan", propertyLink: "/buy" },
          { propertyName: "Real estate in Benin City", propertyLink: "/buy" },
        ],
    },
    {
      id: "New homes",
      title: "New homes",
      links: [
        { propertyName: "Home builders Lagos", propertyLink: "/buy" },
        { propertyName: "House and land Abuja", propertyLink: "/buy" },
        { propertyName: "New homes in Benin City", propertyLink: "/buy" },
      ],
    },
    {
      id: "Popular areas",
      title: "Popular areas",
      links: [
        { propertyName: "Lekki property prices", propertyLink: "/buy" },
        { propertyName: "Ajah property prices", propertyLink: "/buy" },
        { propertyName: "Maitama house prices", propertyLink: "/buy" },
      ],
    },
    {
      id: "Popular searches",
      title: "Popular searches",
      links: [
        { propertyName: "Nigeria property news", propertyLink: "/blog" },
        { propertyName: "Mortgage calculator Nigeria", propertyLink: "/buy" },
        { propertyName: "Selling property in Lagos", propertyLink: "/buy" },
      ],
    },
  ];

  const toggleAccordion = (id) => {
    setOpenAccordions((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const icon = [
    {
      icons: FaFacebook,
      link: "https://www.facebook.com/myrealestate.ng.2023",
      iconsColor: "hover:text-blue-500",
    },
    // {
    //   icons: FaLinkedin,
    //   link: "https://in.linkedin.com/",
    //   iconsColor: "hover:text-[#0A66C2]",
    // },
    {
      icons: FaPinterest,
      link: "https://in.pinterest.com/myrealestateng/",
      iconsColor: "hover:text-[#E60023]",
    },
    {
      icons: FaTwitter,
      link: "https://twitter.com/myrealestateng",
      iconsColor: "hover:text-[#1d9bf0]",
    },
    {
      icons: FaYoutube,
      link: "https://www.youtube.com/",
      iconsColor: "hover:text-[#F00]",
    },
  ];
  const navi = [
    {
      id: 1,
      name: "Advertise with us",
      link: "/advertise",
    },
    {
      id: 2,
      name: "Contact us",
      link: "/contactus",
    },

    // {
    //   id: 3,
    //   name: "Agent admin",
    //   link: "#",
    // },
    {
      id: 4,
      name: "Media sales",
      link: "/contactus",
    },
    {
      id: 5,
      name: "Legal",
      link: "/contactus",
    },
    {
      id: 6,
      name: "Privacy",
      link: "/contactus",
    },
    {
      id: 7,
      name: "Site map",
      link: "/contactus",
    },
    {
      id: 8,
      name: "Careers",
      link: "/contactus",
    },
  ];

  return (
    <footer className="bg-[#F3F6F9] lg:bg-transparent">
      <div className="lg:hidden">
        <div className="bg-white overflow-hidden">
          <div className="flex justify-center pt-8 pb-6">
            <Link to="/" className="flex items-center gap-2">
              <img
                src={logo}
                alt="logo"
                className="h-12 w-12 sm:h-14 sm:w-14"
              />
              <span className="font-semibold text-lg text-[#000929]">
                My Real Estate
              </span>
            </Link>
          </div>
          <div className="border-t border-gray-200">
            {accordionSections.map((section) => (
              <div
                key={section.id}
                className="border-b border-gray-200 last:border-b-0"
              >
                <button
                  type="button"
                  onClick={() => toggleAccordion(section.id)}
                  className="w-full flex items-center justify-between py-4 px-4 sm:px-6 text-left font-semibold text-[#000929] text-sm sm:text-base"
                >
                  <span>{section.title}</span>
                  {openAccordions[section.id] ? (
                    <ChevronUp className="w-5 h-5 text-gray-500 flex-shrink-0" />
                  ) : (
                    <ChevronDown className="w-5 h-5 text-gray-500 flex-shrink-0" />
                  )}
                </button>
                {openAccordions[section.id] && (
                  <div className="px-4 pb-4 sm:px-6 sm:pb-5">
                    <ul className="flex flex-col gap-2">
                      {section.links.map((item, idx) => (
                        <li key={idx}>
                          <Link
                            to={item.propertyLink || "#"}
                            className="text-gray-600 hover:text-[#097FE6] text-sm pl-1"
                          >
                            {item.propertyName}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ))}
            <div className="border-b border-gray-200">
              <button
                type="button"
                onClick={() => toggleAccordion("Company")}
                className="w-full flex items-center justify-between py-4 px-4 sm:px-6 text-left font-semibold text-[#000929] text-sm sm:text-base"
              >
                <span>Company</span>
                {openAccordions.Company ? (
                  <ChevronUp className="w-5 h-5 text-gray-500 flex-shrink-0" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-gray-500 flex-shrink-0" />
                )}
              </button>
              {openAccordions.Company && (
                <div className="px-4 pb-4 sm:px-6 sm:pb-5">
                  <ul className="flex flex-col gap-2">
                    {navi.map((data) => (
                      <li key={data.id}>
                        <Link
                          to={data.link}
                          className="text-gray-600 hover:text-[#097FE6] text-sm pl-1"
                        >
                          {data.name}
                        </Link>
                      </li>
                    ))}
                    <li>
                      <a
                        href="https://agent.myrealestate-ng.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-600 hover:text-[#097FE6] text-sm pl-1"
                      >
                        Agent admin
                      </a>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
          <div className="border-t border-gray-200 py-5 px-4 sm:px-6">
            <p className="font-semibold text-[#000929] text-sm mb-3">
              Follow us on
            </p>
            <div className="flex gap-4">
              {icon.map((i, index) => (
                <a
                  href={i.link}
                  key={index}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-[#097FE6] text-white flex items-center justify-center hover:opacity-90"
                >
                  <i.icons className="text-lg" />
                </a>
              ))}
            </div>
          </div>
          <div className="border-t border-gray-200 py-4 text-center">
            <p className="text-gray-500 text-xs sm:text-sm">
              © {new Date().getFullYear()} My Real Estate. All rights reserved.
            </p>
          </div>
        </div>
      </div>

      <div className="hidden lg:block">
        <div className="container">
          <div className="flex items-center gap-11 mb-12 pt-12">
            <h1 className="text-3xl font-semibold">Follow us on</h1>
            <div className="flex gap-5 justify-center items-start">
              {icon?.map((i, index) => (
                <a
                  href={i?.link}
                  key={index}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#097FE6]"
                >
                  <i.icons className="text-3xl hover:text-[#097FE6]" />
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="w-full h-[2px] bg-gray-200" />
        <div className="container">
          {/* {pathName === "/" ? <FooterTabbing /> : pathName === "/buy" ? <FooterTabbingBuys /> : ""} */}
          <FooterTabbing />
          <div className="w-full h-0.5 bg-[#000929] opacity-20 text-center mb-8" />
          <div className="text-[#404040] mb-8">
            <div className="flex flex-col lg:flex-row items-center gap-12 flex-wrap">
              <div className="flex gap-3">
                <Link to="/" className="flex items-center justify-content-center gap-1 ">
                  <img src={logo} alt="logo" className="h-8 w-8 -mt-2" />
                  <span className="font-semibold text-lg">My Real Estate</span>
                </Link>
              </div>
              <div className="flex justify-center items-center gap-4 mt-2 lg:mt-0 flex-wrap lg:flex-nowrap">
                {navi?.map((data, index) => (
                  <Link
                    key={index}
                    className="md:text-sm text-xs"
                    to={data.link}
                  >
                    {data.name}
                  </Link>
                ))}
                <div className="md:text-sm text-xs">
                  <a
                    href="https://agent.myrealestate-ng.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Agent admin
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
